import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <DModal
  @bodyClass="avatar-selector"
  @closeModal={{@closeModal}}
  @title={{i18n "user.change_avatar.title"}}
  class="avatar-selector-modal"
>
  <:body>
    {{#if this.showSelectableAvatars}}
      <div class="selectable-avatars">
        {{#each this.selectableAvatars as |avatar|}}
          <a
            href
            class="selectable-avatar"
            {{on "click" (fn this.selectAvatar avatar)}}
          >
            {{bound-avatar-template avatar "huge"}}
          </a>
        {{/each}}
      </div>
      {{#if this.showCustomAvatarSelector}}
        <h4>{{i18n "user.change_avatar.use_custom"}}</h4>
      {{/if}}
    {{/if}}
    {{#if this.showCustomAvatarSelector}}
      {{#if this.user.use_logo_small_as_avatar}}
        <div class="avatar-choice">
          <RadioButton
            @id="logo-small"
            @name="logo"
            @value="logo"
            @selection={{this.selected}}
            @onChange={{this.onSelectedChanged}}
          />
          <label class="radio" for="logo-small">
            {{bound-avatar-template
              this.siteSettings.site_logo_small_url
              "large"
            }}
            {{i18n "user.change_avatar.logo_small"}}
          </label>
        </div>
      {{/if}}
      <div class="avatar-choice">
        <RadioButton
          @id="system-avatar"
          @name="avatar"
          @value="system"
          @selection={{this.selected}}
          @onChange={{this.onSelectedChanged}}
        />
        <label class="radio" for="system-avatar">
          {{bound-avatar-template this.user.system_avatar_template "large"}}
          {{i18n "user.change_avatar.letter_based"}}
        </label>
      </div>
      {{#if this.allowAvatarUpload}}
        <div class="avatar-choice">
          <RadioButton
            @id="gravatar"
            @name="avatar"
            @value="gravatar"
            @selection={{this.selected}}
            @onChange={{this.onSelectedChanged}}
          />
          <label class="radio" for="gravatar">
            {{bound-avatar-template this.user.gravatar_avatar_template "large"}}
            <span>
              {{html-safe
                (i18n
                  "user.change_avatar.gravatar"
                  gravatarName=this.siteSettings.gravatar_name
                  gravatarBaseUrl=this.siteSettings.gravatar_base_url
                  gravatarLoginUrl=this.siteSettings.gravatar_login_url
                )
              }}
              {{this.user.email}}
            </span>
          </label>

          <DButton
            @action={{this.refreshGravatar}}
            @translatedTitle={{i18n
              "user.change_avatar.refresh_gravatar_title"
              gravatarName=this.siteSettings.gravatar_name
            }}
            @disabled={{this.gravatarRefreshDisabled}}
            @icon="sync"
            class="btn-default avatar-selector-refresh-gravatar"
          />

          {{#if this.gravatarFailed}}
            <p class="error">
              {{i18n
                "user.change_avatar.gravatar_failed"
                gravatarName=this.siteSettings.gravatar_name
              }}
            </p>
          {{/if}}
        </div>
        <div class="avatar-choice">
          <RadioButton
            @id="uploaded-avatar"
            @name="avatar"
            @value="custom"
            @selection={{this.selected}}
            @onChange={{this.onSelectedChanged}}
          />
          <label class="radio" for="uploaded-avatar">
            {{#if this.user.custom_avatar_template}}
              {{bound-avatar-template this.user.custom_avatar_template "large"}}
              {{i18n "user.change_avatar.uploaded_avatar"}}
            {{else}}
              {{i18n "user.change_avatar.uploaded_avatar_empty"}}
            {{/if}}
          </label>
          <AvatarUploader
            @user_id={{this.user.id}}
            @uploadedAvatarTemplate={{this.user.custom_avatar_template}}
            @uploadedAvatarId={{this.user.custom_avatar_upload_id}}
            @uploading={{this.uploading}}
            @id="avatar-uploader"
            @done={{this.uploadComplete}}
            class="avatar-uploader"
          />
        </div>
      {{/if}}
    {{/if}}
  </:body>

  <:footer>
    {{#if this.showCustomAvatarSelector}}
      <DButton
        @action={{this.saveAvatarSelection}}
        @disabled={{this.submitDisabled}}
        @label="save"
        class="btn-primary"
      />
      <DModalCancel @close={{@closeModal}} />
    {{/if}}
  </:footer>
</DModal>
*/
{
  "id": "bw9dqL8v",
  "block": "[[[8,[39,0],[[24,0,\"avatar-selector-modal\"]],[[\"@bodyClass\",\"@closeModal\",\"@title\"],[\"avatar-selector\",[30,1],[28,[37,1],[\"user.change_avatar.title\"],null]]],[[\"body\",\"footer\"],[[[[1,\"\\n\"],[41,[30,0,[\"showSelectableAvatars\"]],[[[1,\"      \"],[10,0],[14,0,\"selectable-avatars\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"selectableAvatars\"]]],null]],null],null,[[[1,\"          \"],[11,3],[24,6,\"\"],[24,0,\"selectable-avatar\"],[4,[38,5],[\"click\",[28,[37,6],[[30,0,[\"selectAvatar\"]],[30,2]],null]],null],[12],[1,\"\\n            \"],[1,[28,[35,7],[[30,2],\"huge\"],null]],[1,\"\\n          \"],[13],[1,\"\\n\"]],[2]],null],[1,\"      \"],[13],[1,\"\\n\"],[41,[30,0,[\"showCustomAvatarSelector\"]],[[[1,\"        \"],[10,\"h4\"],[12],[1,[28,[35,1],[\"user.change_avatar.use_custom\"],null]],[13],[1,\"\\n\"]],[]],null]],[]],null],[41,[30,0,[\"showCustomAvatarSelector\"]],[[[41,[30,0,[\"user\",\"use_logo_small_as_avatar\"]],[[[1,\"        \"],[10,0],[14,0,\"avatar-choice\"],[12],[1,\"\\n          \"],[8,[39,8],null,[[\"@id\",\"@name\",\"@value\",\"@selection\",\"@onChange\"],[\"logo-small\",\"logo\",\"logo\",[30,0,[\"selected\"]],[30,0,[\"onSelectedChanged\"]]]],null],[1,\"\\n          \"],[10,\"label\"],[14,0,\"radio\"],[14,\"for\",\"logo-small\"],[12],[1,\"\\n            \"],[1,[28,[35,7],[[30,0,[\"siteSettings\",\"site_logo_small_url\"]],\"large\"],null]],[1,\"\\n            \"],[1,[28,[35,1],[\"user.change_avatar.logo_small\"],null]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"      \"],[10,0],[14,0,\"avatar-choice\"],[12],[1,\"\\n        \"],[8,[39,8],null,[[\"@id\",\"@name\",\"@value\",\"@selection\",\"@onChange\"],[\"system-avatar\",\"avatar\",\"system\",[30,0,[\"selected\"]],[30,0,[\"onSelectedChanged\"]]]],null],[1,\"\\n        \"],[10,\"label\"],[14,0,\"radio\"],[14,\"for\",\"system-avatar\"],[12],[1,\"\\n          \"],[1,[28,[35,7],[[30,0,[\"user\",\"system_avatar_template\"]],\"large\"],null]],[1,\"\\n          \"],[1,[28,[35,1],[\"user.change_avatar.letter_based\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,0,[\"allowAvatarUpload\"]],[[[1,\"        \"],[10,0],[14,0,\"avatar-choice\"],[12],[1,\"\\n          \"],[8,[39,8],null,[[\"@id\",\"@name\",\"@value\",\"@selection\",\"@onChange\"],[\"gravatar\",\"avatar\",\"gravatar\",[30,0,[\"selected\"]],[30,0,[\"onSelectedChanged\"]]]],null],[1,\"\\n          \"],[10,\"label\"],[14,0,\"radio\"],[14,\"for\",\"gravatar\"],[12],[1,\"\\n            \"],[1,[28,[35,7],[[30,0,[\"user\",\"gravatar_avatar_template\"]],\"large\"],null]],[1,\"\\n            \"],[10,1],[12],[1,\"\\n              \"],[1,[28,[35,9],[[28,[37,1],[\"user.change_avatar.gravatar\"],[[\"gravatarName\",\"gravatarBaseUrl\",\"gravatarLoginUrl\"],[[30,0,[\"siteSettings\",\"gravatar_name\"]],[30,0,[\"siteSettings\",\"gravatar_base_url\"]],[30,0,[\"siteSettings\",\"gravatar_login_url\"]]]]]],null]],[1,\"\\n              \"],[1,[30,0,[\"user\",\"email\"]]],[1,\"\\n            \"],[13],[1,\"\\n          \"],[13],[1,\"\\n\\n          \"],[8,[39,10],[[24,0,\"btn-default avatar-selector-refresh-gravatar\"]],[[\"@action\",\"@translatedTitle\",\"@disabled\",\"@icon\"],[[30,0,[\"refreshGravatar\"]],[28,[37,1],[\"user.change_avatar.refresh_gravatar_title\"],[[\"gravatarName\"],[[30,0,[\"siteSettings\",\"gravatar_name\"]]]]],[30,0,[\"gravatarRefreshDisabled\"]],\"sync\"]],null],[1,\"\\n\\n\"],[41,[30,0,[\"gravatarFailed\"]],[[[1,\"            \"],[10,2],[14,0,\"error\"],[12],[1,\"\\n              \"],[1,[28,[35,1],[\"user.change_avatar.gravatar_failed\"],[[\"gravatarName\"],[[30,0,[\"siteSettings\",\"gravatar_name\"]]]]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"avatar-choice\"],[12],[1,\"\\n          \"],[8,[39,8],null,[[\"@id\",\"@name\",\"@value\",\"@selection\",\"@onChange\"],[\"uploaded-avatar\",\"avatar\",\"custom\",[30,0,[\"selected\"]],[30,0,[\"onSelectedChanged\"]]]],null],[1,\"\\n          \"],[10,\"label\"],[14,0,\"radio\"],[14,\"for\",\"uploaded-avatar\"],[12],[1,\"\\n\"],[41,[30,0,[\"user\",\"custom_avatar_template\"]],[[[1,\"              \"],[1,[28,[35,7],[[30,0,[\"user\",\"custom_avatar_template\"]],\"large\"],null]],[1,\"\\n              \"],[1,[28,[35,1],[\"user.change_avatar.uploaded_avatar\"],null]],[1,\"\\n\"]],[]],[[[1,\"              \"],[1,[28,[35,1],[\"user.change_avatar.uploaded_avatar_empty\"],null]],[1,\"\\n\"]],[]]],[1,\"          \"],[13],[1,\"\\n          \"],[8,[39,11],[[24,0,\"avatar-uploader\"]],[[\"@user_id\",\"@uploadedAvatarTemplate\",\"@uploadedAvatarId\",\"@uploading\",\"@id\",\"@done\"],[[30,0,[\"user\",\"id\"]],[30,0,[\"user\",\"custom_avatar_template\"]],[30,0,[\"user\",\"custom_avatar_upload_id\"]],[30,0,[\"uploading\"]],\"avatar-uploader\",[30,0,[\"uploadComplete\"]]]],null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null]],[]],null],[1,\"  \"]],[]],[[[1,\"\\n\"],[41,[30,0,[\"showCustomAvatarSelector\"]],[[[1,\"      \"],[8,[39,10],[[24,0,\"btn-primary\"]],[[\"@action\",\"@disabled\",\"@label\"],[[30,0,[\"saveAvatarSelection\"]],[30,0,[\"submitDisabled\"]],\"save\"]],null],[1,\"\\n      \"],[8,[39,12],null,[[\"@close\"],[[30,1]]],null],[1,\"\\n\"]],[]],null],[1,\"  \"]],[]]]]]],[\"@closeModal\",\"avatar\"],false,[\"d-modal\",\"i18n\",\"if\",\"each\",\"-track-array\",\"on\",\"fn\",\"bound-avatar-template\",\"radio-button\",\"html-safe\",\"d-button\",\"avatar-uploader\",\"d-modal-cancel\"]]",
  "moduleName": "discourse/components/modal/avatar-selector.hbs",
  "isStrictMode": false
});